import './App.css';
import ReactPort from './components/ReactPort';

function App() {
  return (
    <div className="react-app">
      <ReactPort />
    </div>
  );
}

export default App;